/* istanbul ignore file */

import moment from "moment";

export type DateString = string;

export const formatDateMixin = {
	methods: {
		dateStringWithZeroHourOffset(value: Date) {
			return value ? moment(value + "Z") : "";
		},
		displayTimeFromISOString(value: DateString | Date) {
			return value ? moment(value).format("LTS") : "";
		},
		displayDateFromISOString(value: DateString | Date) {
			return value ? moment(value).format("L LTS") : "";
		},
		convertUtcDateTimeToLocalDateTimeString(value: DateString | Date) {
			return value ? moment(value + "Z").format("L LTS") : "";
		},
		convertUtcDateTimeToLocalTimeString(value: DateString | Date) {
			return value ? moment(value + "Z").format("LTS") : "";
		},
		fromNow(value: Date) {
			return value ? moment(value + "Z").fromNow() : "";
		},
		displayUnParkAt(value?: Date) {
			return value ? moment(value + "Z").format("L LTS") : null;
		},
		currentDateFormatted() {
			return moment().format();
		},
		endOFDayFormatted() {
			return moment()
				.endOf("day")
				.format();
		},
		weekAgoDateFormatted() {
			return moment()
				.subtract(7, "days")
				.format();
		},
		toStartOfDay(value: string) {
			return moment(value)
				.startOf("day")
				.format();
		},
		toEndOfDay(value: string) {
			return moment(value)
				.endOf("day")
				.format();
		},
		relativeDaysDateFormatted(days: number) {
			days = days === undefined ? 7 : days;
			return moment()
				.subtract(days, "days")
				.format("YYYY-MM-DDTHH:mm:ss.000Z");
		},
		formatDateStr(dateStr, timeOnly = false, convertFromUTC = false, includePeriod = true, dateOnly = false) {
			if (dateStr) {
				if (convertFromUTC && !dateStr.includes("Z")) {
					dateStr += "Z";
				}

				const date = new Date(dateStr);

				const monthNames = [
					"Jan",
					"Feb",
					"March",
					"April",
					"May",
					"June",
					"July",
					"Aug",
					"Sept",
					"Oct",
					"Nov",
					"Dec"
				];

				const day = date.getDate();
				const monthIndex = date.getMonth();
				const year = date.getFullYear();
				const hours = date.getHours();
				const mins = date.getMinutes();

				let formattedDate = "";

				if (!timeOnly) {
					formattedDate += day + " " + monthNames[monthIndex] + " " + year;
				}

				if (!dateOnly) {
					formattedDate +=
						" " +
						(hours < 10 ? "0" : "") +
						hours +
						":" +
						(mins < 10 ? "0" : "") +
						mins +
						" " +
						(includePeriod ? (hours < 12 ? "am" : "pm") : "");
				}
				return formattedDate.trim();
			}
		}
	}
};

export const stringMixin = {
	methods: {
		isNullOrWhitespace(input: string) {
			return !input || !input.trim();
		},

		formatString(str: string, ...args: any[]) {
			return str.replace(/{(\d+)}/g, function(match, num) {
				return typeof args[num] != "undefined" ? args[num] : match;
			});
		}
	}
};

export const licenseMixins = {
	methods: {
		isLicenseLimitUnlimited(limit: number) {
			const maximumUsageUpperLimit = 2000000000;
			return limit > maximumUsageUpperLimit;
		}
	}
};
